import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/app/news/[slug]/NewsInteractions.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/app/news/[slug]/NewsShareSection.js");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/components/Breadcrumb.module.css");
;
import(/* webpackMode: "eager" */ "/var/www/gerelt/front/app/news/[slug]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/components/SafeHTML.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/gerelt/front/node_modules/next/dist/client/app-dir/link.js");
